let gameItem=null;
export function setGameItem(item)
{
    gameItem = item;
}

export function getGameItem(){
    return gameItem;
}